import { call, put, takeLatest } from 'redux-saga/effects';
import { ClaimApi } from '@apis/ClaimApi';
import { claimQuickUpdate, claimQuickUpdateSuccess, claimQuickUpdateError, ClaimQuickUpdatePayload } from './action';
import { SagaPayload } from '@utils/typescript';
import { toastShow } from '@components/ToastProvider';
import i18n from '@components/i18n';

function* handleClaimQuickUpdate({ payload }: SagaPayload<ClaimQuickUpdatePayload>) {
  const { claimableType, claimableId, status, totalClaimedAmount } = payload;
  try {
    yield call(ClaimApi.put, {
      claimableType,
      claimableId,
      status,
      totalClaimedAmount,
      note: '',
    });
    yield put(claimQuickUpdateSuccess({ claimableType, claimableId }));
    yield put(toastShow({ status: 'success', body: i18n.t('toast.claimUpdate.success') }));
  } catch (e) {
    yield put(claimQuickUpdateError({ claimableType, claimableId }));
    yield put(toastShow({ status: 'danger', body: i18n.t('toast.claimUpdate.error') }));
  }
}

export default function* () {
  yield takeLatest(claimQuickUpdate, handleClaimQuickUpdate);
}
